import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getNfoOverview } from "../actions";
import { closePopup, openPopup } from "../../../general/Modal/action";
import { MODALS } from "../../../general/Modal/constants";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { CSVLink } from "react-csv";
import "react-tabs/style/react-tabs.css";
import "../../AboutUs/style.scss";
import "./style.scss";
import "../style.scss";
import Modal from "react-modal";
import {
  getRouting,
  checkIframeContent,
  formDataGenerator
} from "../../../../../utils/common";
import ReactPlayer from "react-player";
import SocialShare from "../../../general/socials";
import PageNotFound from "../../PageNotFound";

const NfoOverview = (props) => {
  const {
    location: { pathname },
    getNfoOverview,
    nfoOverview,
    openPopup,
    closePopup,
  } = props;

  const [toggleGraph, settoggleGraph] = useState(false);
  const [productDetail, setproductDetail] = useState();
  const [toggleButton, settoggleButton] = useState(false);
  const [defaultVideo, setdefaultVideo] = useState([]);
  const [productArticleYear, setProductArticleYear] = useState();
  const [productVideoLimit, setproductVideoLimit] = useState();
  const [productpodcastLimit, setproductpodcastLimit] = useState();
  const [productarticleLimit, setproductarticleLimit] = useState();
  const [productarticleSearch, setproductarticleSearch] = useState();
  const [sticky, setSticky] = useState("");
  const [stickyWeb, setStickyWeb] = useState("");
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const [smallCaseTxn, setsmallCaseTxn] = useState(false);

  //modal1
  const [modalshow, setModalShow] = useState(false);
  const modalhandleClose = () => setModalShow(false);
  const modalhandleShow = () => {
    setModalShow(true);
    // setcompareSelectedArray([...compareselectedArray, productNodeID]);
  };

  const handleGraph = (event) => {
    settoggleGraph(event.target.checked);
  };

  // const handleCompareCheckBox = (e) => {
  //   const myArray = [];

  //   // add value to array

  const handleChangeVideo = async (e, item) => {
    setdefaultVideo(item);
  };

  // const handleYearProduct = (e) => {
  //   setProductArticleYear(e.target.value);
  // };

  // const handleVideoLimit = (e, limit) => {
  //   setproductVideoLimit(limit);
  // };

  // const handlePodcastLimit = (e, limit) => {
  //   setproductpodcastLimit(limit);
  // };

  // const handleArticleLimit = (e, limit) => {
  //   setproductarticleLimit(limit);
  // };

  // const handleSearchArticle = async (e) => {
  //   setproductarticleSearch(e.target.value);
  // };

  const [investBtn, setinvestBtn] = useState();
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    /* Method that will fix header after a specific scrollable */
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 250 ? "is-sticky" : "";
    setSticky(stickyClass);
    const investbtn = scrollTop >= 250 ? "d-block" : "d-none";
    setinvestBtn(investbtn);
    const stickyClassweb = scrollTop >= 250 ? "is-stickyweb" : "";
    setStickyWeb(stickyClassweb);
  };

  const btndiv = `ms-auto ${investBtn}`;

  const classes = `menu mt-4 header-section d-xl-block ${sticky}`;
  const classesWebview = `menu mt-4 header-section d-xl-block ${stickyWeb}`;

  const handleClickShare = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
    setShare(true);
  };
  const addTodo = () => {
    setShare(false);
  };
  const sharename = "";
  // const tickerValue =
  //   productDetailOverview &&
  //   productDetailOverview.productOverview &&
  //   productDetailOverview.productOverview.banner &&
  //   productDetailOverview.productOverview.banner.ticker;

  // const etfBtn = pathname.split("/")[3];

  //fundacord start
  const [fundSelected, setfundSelected] = useState(null);
  const fundtoggle = (index) => {
    if (fundSelected === index) {
      return setfundSelected(null);
    }
    setfundSelected(index);
  };

  //fundacord end

  //Overseas start
  const [overseasSelected, setoverseasSelected] = useState(null);
  const overseastoggle = (index) => {
    if (overseasSelected === index) {
      return setoverseasSelected(null);
    }
    setoverseasSelected(index);
  };

  //Overseas end

  //faqacord start
  const [faqSelected, setfaqSelected] = useState(null);
  const faqtoggle = (index) => {
    if (faqSelected === index) {
      return setfaqSelected(null);
    }
    setfaqSelected(index);
  };

  //faqacord end

  // useEffect(()=>{
  //   let params = {
  //    type:{}
  //   };
  //   getNfoOverview(formDataGenerator(params));
  // })

  useEffect(() => {
    let pageurl = pathname.split("/")[3] ? pathname.split("/")[3] : "";
    let formData = pathname.split("/")[4];

    if (formData === "direct") {
      formData = "direct";
    } else {
      formData = "indirect";
      settoggleButton(true);
    }
    let data = formDataGenerator({
      plan_type : formData
    })
    getNfoOverview({},data,pageurl);
  }, []);

  const [nfoPage, setnfoPage] = useState();

  useEffect(() => {
    if (nfoOverview && nfoOverview.nfoOverviewpage) {
      setnfoPage(nfoOverview.nfoOverviewpage);
    }
  }, [nfoOverview]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = document.querySelectorAll('section[id]');
      const scrollPosition = window.scrollY;
 
      sectionElements.forEach(section => {
        const { top, bottom } = section.getBoundingClientRect();
        if (top <= 250 && bottom > 0) {
          setActiveSection(section.id);
        }
      });
    };
 
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handlePlanChange = (e) => {
    settoggleButton(e.target.checked);
    let pageurl = pathname.split("/")[3] ? pathname.split("/")[3] : "";

    let togglrForm = "";
    if (e.target.checked == false) {
      togglrForm = "direct";
    } else {
      togglrForm = "indirect";
    }
    let data = formDataGenerator({
      plan_type : togglrForm
    })
    getNfoOverview({},data,pageurl);
  }

  const onAddToCartClick = (fundName, fundCode, returnVal) => {
    let modalData = {
      modalClass: "ecart-modal",
      fundName: fundName,
      fundCode: fundCode,
      isDirect: toggleButton == false ? true : false,
      isRegular: toggleButton == true ? true : false,
      returnValue: { duration: "11", value: returnVal ? returnVal : "" },
    };
    openPopup(MODALS.ECART_MODAL, modalData);
  };

  return (
    <div className={checkIframeContent() ? "wrapper":""}>
      {pathname.split("/")[4] == 'direct' || pathname.split("/")[4] == 'regular' ? <>
      <Helmet>
        <title>{nfoPage && nfoPage.meta && nfoPage.meta.title}</title>
      </Helmet>
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="dropdown me-auto">
              <div
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <p>
                  <span>Product &</span> Solutions
                </p>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                {checkIframeContent() && <li className="breadcrumb-item d-flex">
                  <a href="/">Home</a>
                </li>}
                <li className="breadcrumb-item d-flex">
                {checkIframeContent() ? <a href="/product-solutions/nfo">Products</a> :<Link to={getRouting("/product-solutions/nfo")}>Products</Link>}
                </li>
                <li className="breadcrumb-item d-flex">
                 
                    {nfoPage && nfoPage.banner && nfoPage.banner.title}
                 
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="lightgraybg">
        <section className="addtocartrow my-4">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8 d-flex align-items-center">
                <h1> {nfoPage && nfoPage.banner && nfoPage.banner.title}</h1>
                <div className="directregularNfodiv">
                  <div className="form-check form-switch d-flex ms-3 share-icon align-items-center">
                  <label className="form-check-label">Direct</label>
                    <Link
                      to={getRouting(
                        `/product-solutions/nfo-overview/${
                          nfoPage &&
                          nfoPage.banner &&
                          nfoPage.banner.suggestedUrl
                        }/${toggleButton == false ? "regular" : "direct"}`
                      )}
                    >
                    <input 
                    className="form-check-input colorSwitch" 
                    type="checkbox" 
                    role="switch" 
                    id="flexSwitchCheckDefault1"
                    onClick={(e) => handlePlanChange(e)}
                    checked={toggleButton} 
                    />
                    </Link>
                  <label className="form-check-label" for="flexSwitchCheckDefault">Regular</label>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 d-flex justify-content-end align-items-center fundicon">
                <div className="toggledivnfo">
                  <div className="form-check form-switch d-flex share-icon align-items-center">
                    <label className="form-check-label">Direct</label>
                    <Link
                      to={getRouting(
                        `/product-solutions/nfo-overview/${
                          nfoPage &&
                          nfoPage.banner &&
                          nfoPage.banner.suggestedUrl
                        }/${toggleButton == false ? "regular" : "direct"}`
                      )}
                    >
                      <input className="form-check-input colorSwitch" 
                      type="checkbox" 
                      role="switch" 
                      id="flexSwitchCheckDefault1" 
                      onClick={(e) => handlePlanChange(e)}
                      checked={toggleButton}  />
                    </Link>
                    <label className="form-check-label" for="flexSwitchCheckDefault">Regular</label>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                {nfoPage && nfoPage.banner && nfoPage.banner.hideInvest == false &&  nfoPage.banner.categories && (nfoPage.banner.categories[0] != 'ETF' && nfoPage.banner.categories[0] != undefined) ? <>
                  {checkIframeContent() &&<a className="d-flex align-items-center cartnfo me-2" 
                    onClick={() =>
                              onAddToCartClick(
                                nfoPage && nfoPage.banner && nfoPage.banner.title,
                                nfoPage && nfoPage.banner && nfoPage.banner.fundCode
                              )
                            }>
                      <img 
                        src="/images/New/product-solution/Iconsaddtocart.svg" alt="carticon"
                        width="25"
                        height="25"
                        className="img-fluid cursorp me-2"
                      />
                      <span className="cartname">Cart</span>
                  </a>}
                  </>:''}
                  {checkIframeContent() && <a>
                    <div
                      className="d-flex align-items-center sharebtn cursorp"
                      onClick={() => handleClickShare(0)}
                    >
                      <img
                        src="/images/New/product-solution/share.svg"
                        width="18"
                        height="18"
                        className="img-fluid"
                      />
                      <span className="mnone cartname ms-2">Share</span>
                      {share && cardId === 0 && (
                        <SocialShare fundName={sharename} addTodo={addTodo} />
                      )}
                    </div>
                  </a>}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="badgerowNfo my-4">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mb-4 mb-md-0 order-1 order-md-0">
                <div>
                  <span className="fundtypenfo darkcolor me-2">Fund Type:</span>

                  {nfoPage &&
                    nfoPage.banner &&
                    nfoPage.banner.categories &&
                    nfoPage.banner.categories.length > 0 &&
                    nfoPage.banner.categories.map((item) => (
                      <span className="badge rounded-pill me-2">{item}</span>
                    ))}
                </div>
              </div>
              {nfoPage &&
              nfoPage.banner &&
              nfoPage.banner.hideInvest == false ? <>
                {checkIframeContent() && <div className="col-md-6 d-flex mb-4 mb-md-0 order-0 order-md-1 investbtnblu">
                  <div className="mx-auto ms-md-auto me-md-0 buttondivv">
                    <a
                      className="btn-blue ms-3 text-center"
                      href={
                        nfoPage && nfoPage.banner && nfoPage.banner.investUrl
                      }
                    >
                      Invest Now
                    </a>
                  </div>
                </div>}
              </> : (
                ""
              )}
            </div>
            <div className={checkIframeContent() ? classes : classesWebview}>
              <ul className="nfoscrollnav">
                <li className={sticky ? "" : "defaultactive"}>
                  <a href="#overview" className={activeSection === 'overview' ? 'active' : ''}>
                    Overview
                  </a>
                </li>
                {nfoPage &&
              nfoPage.details &&
              nfoPage.details[1] &&
              ((nfoPage.details[1].managers &&
              nfoPage.details[1].managers.length > 0) ||
              (nfoPage.details[1].overseasManagers &&
              nfoPage.details[1].overseasManagers.length > 0)) ?
                <li>
                  <a href="#fundmanagers" className={activeSection === 'fundmanagers' ? 'active' : ''}>
                    Fund Managers
                  </a>
                </li>
                :''}
                {nfoPage &&
                nfoPage.details &&
                nfoPage.details[2] &&
                ((nfoPage.details[2].schemeSummaryFiles &&
                nfoPage.details[2].schemeSummaryFiles.length > 0) || 
                (nfoPage.details[2].values &&
                nfoPage.details[2].values.length > 0)) ?
                <li>
                  <a href="#scheme-documents" className={activeSection === 'scheme-documents' ? 'active' : ''}>
                    Scheme Documents
                  </a>
                </li>
                :''}
                {nfoPage &&
                nfoPage.banner &&
                nfoPage.banner.hideInvest == false ? <>
                  {checkIframeContent() && <li>
                    <div className="buttondiv">
                      <a
                        className="btn-blue  ms-3 text-center text-white"
                        href={
                          nfoPage && nfoPage.banner && nfoPage.banner.investUrl
                        }
                      >
                        Invest Now
                      </a>
                    </div>
                  </li>}
                </> : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </section>
      </section>

      <section>
        <div class="container">
          <div className="content overview-section">
              <section id="overview">
                <h2 className="tabheading">Overview</h2>

                <div className="row mb-3">
                  {nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[0] &&
                  nfoPage.details[0].Overview &&
                  nfoPage.details[0].Overview.leaflet &&
                  nfoPage.details[0].Overview.leaflet.file &&
                  nfoPage.details[0].Overview.leaflet.image ? (
                    <>
                      <div className="col-md-5">
                        <div className="overviewproduct">
                          <img
                            className="img-fluid w-100"
                            src={
                              nfoPage &&
                              nfoPage.details &&
                              nfoPage.details[0] &&
                              nfoPage.details[0].Overview &&
                              nfoPage.details[0].Overview.leaflet &&
                              nfoPage.details[0].Overview.leaflet.image
                            }
                          />
                          <div className="productDownload">
                            {nfoPage &&
                            nfoPage.details &&
                            nfoPage.details[0] &&
                            nfoPage.details[0].Overview &&
                            nfoPage.details[0].Overview.leaflet &&
                            nfoPage.details[0].Overview.leaflet.file ? (
                              <a
                                href={nfoPage.details[0].Overview.leaflet.file}
                                target="_blank"
                              >
                                <img src="/images/New/product-solution/productDownload.svg" />
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-7 mt-4 mt-md-0">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.overviewDescription ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                nfoPage.details[0].Overview.overviewDescription,
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-md-12 mt-4 mt-md-0">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.overviewDescription ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                nfoPage.details[0].Overview.overviewDescription,
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}
                </div>

                <div className="overview-wrap">
                  <ul className="nfooverviewdata">
                    <li>
                      <div>Suggested For</div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.suggestedFor
                          ? nfoPage.details[0].Overview.suggestedFor
                          : "NA"}
                      </div>
                    </li>
                    <li>
                      <div>Start Date</div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.startDate
                          ? nfoPage.details[0].Overview.startDate
                          : "NA"}
                      </div>
                    </li>
                    <li>
                      <div>End Date</div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.endDate
                          ? nfoPage.details[0].Overview.endDate
                          : "NA"}
                      </div>
                    </li>
                    <li>
                      <div>
                        Riskometer
                        <div className="tooltip">
                          <img src="/images/New/product-solution/info.svg" className="infoicon" />
                          <div className="tooltiptext">
                            <img
                              className="w-100 h-100 m-0 p-0 imgSize"
                              src={
                                nfoPage &&
                                nfoPage.details &&
                                nfoPage.details[0] &&
                                nfoPage.details[0].Overview &&
                                nfoPage.details[0].Overview.risk &&
                                nfoPage.details[0].Overview.risk[0] &&
                                nfoPage.details[0].Overview.risk[0].iconUrl &&
                                nfoPage.details[0].Overview.risk[0]
                                  .iconUrl[0] &&
                                nfoPage.details[0].Overview.risk[0].iconUrl[0]
                                  .value
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.risk &&
                        nfoPage.details[0].Overview.risk[0] &&
                        nfoPage.details[0].Overview.risk[0].name
                          ? nfoPage.details[0].Overview.risk[0].name
                          : ""}
                      </div>
                    </li>
                    <li>
                      <div>Suitable For</div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.suitable &&
                        nfoPage.details[0].Overview.suitable[0] &&
                        nfoPage.details[0].Overview.suitable[0].name
                          ? nfoPage.details[0].Overview.suitable[0].name
                          : "NA"}
                      </div>
                    </li>
                    <li>
                      <div>Benchmark for Fund</div>
                      <div className="overview-heading">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.benchmark &&
                        nfoPage.details[0].Overview.benchmark[0]
                          ? nfoPage.details[0].Overview.benchmark[0]
                          : "NA"}
                      </div>
                    </li>
                  </ul>
                </div>
              </section>
              {nfoPage &&
                nfoPage.details &&
                nfoPage.details[1] &&
                ((nfoPage.details[1].managers &&
                nfoPage.details[1].managers.length > 0) ||
                (nfoPage.details[1].overseasManagers &&
                nfoPage.details[1].overseasManagers.length > 0)) ? 
              <section id="fundmanagers" className="fund-managers">
                {nfoPage &&
                nfoPage.details &&
                nfoPage.details[1] &&
                nfoPage.details[1].managers &&
                nfoPage.details[1].managers.length > 0 ? (
                  <h2 className="tabheading">Fund Managers</h2>
                ) : (
                  ""
                )}
                <div className="accordion fundacord">
                  {nfoPage &&
                    nfoPage.details &&
                    nfoPage.details[1] &&
                    nfoPage.details[1].managers &&
                    nfoPage.details[1].managers.length > 0 &&
                    nfoPage.details[1].managers.map((item, index) => (
                      <div className="item">
                        <div
                          className="title"
                          onClick={() => fundtoggle(index)}
                        >
                          <div className="d-flex align-items-center">
                            <div>
                              {item && item.profileUrl ? (
                                <img
                                  src={item && item.profileUrl}
                                  className="fund-managers-avatar"
                                />
                              ) : (
                                <img
                                  src="https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/CampaignImages/account+(1).png"
                                  className="fund-managers-avatar"
                                />
                              )}
                            </div>
                            <div>
                              <h3 className="darkcolor mb-2">
                                {item.managerName ? item.managerName : ""}
                              </h3>
                              <div className="normaltext">
                                {item.desgination ? item.desgination : ""}
                              </div>
                            </div>
                          </div>
                          <div>
                            <img
                              className={fundSelected === index ? "rotate" : ""}
                              src="/images/New/redDownArrow.svg"
                            />
                          </div>
                        </div>
                        <div
                          className={
                            fundSelected === index ? "content show" : "content"
                          }
                        >
                          <div>
                            {item.information ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.information,
                                }}
                              />
                            ) : (
                              ""
                            )}

                            <div className="my-3 darkcolor fund-managers-subheading">
                              {item &&
                              item.other_funds &&
                              item.other_funds.title
                                ? item.other_funds.title
                                : ""}
                            </div>
                            <div className="d-flex flex-wrap">
                              {item &&
                                item.other_funds &&
                                item.other_funds.values &&
                                item.other_funds.values.length > 0 &&
                                item.other_funds.values.map((row) => (
                                  <span className="badge rounded-pill me-2">
                                    {row.title}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
                {nfoPage &&
                nfoPage.details &&
                nfoPage.details[1] &&
                nfoPage.details[1].overseasManagers &&
                nfoPage.details[1].overseasManagers.length > 0 ? (
                  <h2 className="tabheading">Overseas Fund Managers</h2>
                ) : (
                  ""
                )}

                <div className="accordion Overseas">
                  {nfoPage &&
                    nfoPage.details &&
                    nfoPage.details[1] &&
                    nfoPage.details[1].overseasManagers &&
                    nfoPage.details[1].overseasManagers.length > 0 &&
                    nfoPage.details[1].overseasManagers.map((item, index) => (
                      <div className="item">
                        <div
                          className="title"
                          onClick={() => overseastoggle(index)}
                        >
                          <div className="d-flex align-items-center">
                            <div>
                              {item && item.profileUrl ? (
                                <img
                                  src={item && item.profileUrl}
                                  className="fund-managers-avatar"
                                />
                              ) : (
                                <img
                                  src="https://s3.ap-south-1.amazonaws.com/files.hdfcfund.com/CampaignImages/account+(1).png"
                                  className="fund-managers-avatar"
                                />
                              )}
                            </div>
                            <div>
                              <h3 className="darkcolor">
                                {item.managerName ? item.managerName : ""}
                              </h3>
                              <div className="normaltext">
                                {item.desgination ? item.desgination : ""}
                              </div>
                            </div>
                          </div>
                          <div>
                            <img
                              className={
                                overseasSelected === index ? "rotate" : ""
                              }
                              src="/images/New/redDownArrow.svg"
                            />
                          </div>
                        </div>

                        <div
                          className={
                            overseasSelected === index
                              ? "content show"
                              : "content"
                          }
                        >
                          <div>
                            {item.information ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.information,
                                }}
                              />
                            ) : (
                              ""
                            )}

                            <div className="my-3 darkcolor fund-managers-subheading">
                              {item &&
                              item.other_funds &&
                              item.other_funds.title
                                ? item.other_funds.title
                                : ""}
                            </div>
                            <div className="d-flex flex-wrap">
                              {item &&
                                item.other_funds &&
                                item.other_funds.values &&
                                item.other_funds.values.length > 0 &&
                                item.other_funds.values.map((row) => (
                                  <span className="badge rounded-pill me-2">
                                    {row.title}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </section>
              :''}
              {nfoPage &&
                nfoPage.details &&
                nfoPage.details[2] &&
                ((nfoPage.details[2].schemeSummaryFiles &&
                nfoPage.details[2].schemeSummaryFiles.length > 0) || 
                (nfoPage.details[2].values &&
                nfoPage.details[2].values.length > 0)) ?
                <section id="scheme-documents">
                  <div className="d-md-flex d-block scheme-documents">
                    <div className="row w-100">
                      <div className="col-md-12">
                        {nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[2] &&
                        nfoPage.details[2].values &&
                        nfoPage.details[2].values.length > 0 ? (
                          <div className="scheme-documents-div">
                            <h2>Scheme Documents</h2>
                          </div>
                        ) : (
                          ""
                        )}
                        <div className="row">
                          {nfoPage &&
                            nfoPage.details &&
                            nfoPage.details[2] &&
                            nfoPage.details[2].values &&
                            nfoPage.details[2].values.length > 0 &&
                            nfoPage.details[2].values.map((item, index) => (
                              <div className="col-md-4">
                                <a
                                  href={item.url}
                                  className="d-flex align-items-center mb-4"
                                  target="_blank"
                                >
                                  <div className="me-3">
                                    <img
                                      src="/images/New/product-solution/download.svg"
                                      alt="download-icon"
                                      className="h-100"
                                    />
                                  </div>
                                  <div>{item.description}</div>
                                </a>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {/* <Tabs className="customTab ">
                      <TabList className="slickOptions">
                        <Tab>
                          <a>
                            <div>Videos</div>
                          </a>
                        </Tab>
                        <Tab>
                          <a>
                            <div>Poadcast</div>
                          </a>
                        </Tab>
                        <Tab>
                          <a>
                            <div>Articles</div>
                          </a>
                        </Tab>
                      </TabList>
                      <TabPanel>
                        <div className="mt-5 row videoimages">
                          <div className="col-md-7 videosec">
                            <a className="d-block">
                              <ReactPlayer
                                className="w-100 h-100 webinarvideo videoplayer"
                                url="https://www.youtube.com/watch?v=tiLWCNFzThE&list=PLwGdqUZWnOp3aROg4wypcRhZqJG3ajZWJ"
                                controls="true"
                              />
                            </a>
                            <div className="webinarp">
                              <h4 className="mt-3">Benefits of Mutual Funds</h4>
                              <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Sagittis amet condimentum ullamcorper est.
                                Elit scelerisque integer at mus sit eu senectus id
                                arcu.
                              </p>
                            </div>
                          </div>
                          <div className="col-md-5 videosecright">
                            <div className="row mb-3">
                              <div className="col-6">
                                <a
                                  href="javascript:void(0)"
                                  onClick={(e) => handleChangeVideo(e, item)}
                                >
                                  <div className="articleimg">
                                    <img
                                      src="/images/New/learnNew/articlesimg.svg"
                                      className="w-100 imgh webinarvideo"
                                    />
                                    <div className="readclsVideo">11.11</div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-6">
                                <div className="webinarp">
                                  <p className="">Episode 1</p>
                                  <p>Introduction to investing in the markets</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex articlebtn">
                          <button
                            type="button"
                            class="btn btn-outline-primary mx-auto"
                            // onClick={(e) => handleVideoLimit()}
                          >
                            View All Videos
                          </button>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div className="podcastdiv mt-4">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row gx-4 mb-4">
                                <div className="col-md-6 mb-4">
                                  <div className="padcastcard">
                                    <div className="row p-3">
                                      <div className="col-md-3 d-flex align-items-center justify-content-center">
                                        <Link to="">
                                          <img
                                            class="img-fluid"
                                            src="/images/New/logo.svg"
                                          />
                                        </Link>
                                      </div>
                                      <div className="col-md-9">
                                        <Link to="">
                                          <h3 className="bluecolor">podcast1</h3>
                                        </Link>
                                        <p className="my-3">
                                          fsdfsdfsdfsdfsdfsdfsf dsfsdfsfdfs sfsf
                                        </p>
                                      </div>
                                      <div className="col-md-12 mt-3">
                                        <audio
                                          preload="auto"
                                          class="w-100"
                                          controls
                                        >
                                          <source src="/images/New/sample-tone.mp3" />
                                        </audio>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex articlebtn">
                                <button
                                  type="button"
                                  class="btn btn-outline-primary mx-auto"
                                  // onClick={(e) => handlePodcastLimit(e, 1)}
                                >
                                  View All Podcasts
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div className="InvestingRefreshers">
                          <div className="">
                            <div className="row">
                              <div className="col-md-8">
                                <p className="fsize mt-4">
                                  Select the Financial Year to View Reports
                                </p>
                                <div className="row mt-3 searchtag">
                                  <div className="col-md-6 mb-4">
                                    <div className="input-group inputt">
                                      <select
                                        className="form-select year-drop py-3"
                                        id="inputGroupSelect04"
                                        aria-label="Example select with button addon"
                                        //   onChange={handleYearProduct}
                                      >
                                        <option value="">select</option>
                                        <option value="2020-2021">
                                          2020-2021
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6 mb-4 searchname">
                                    <div className="input-group mb-3">
                                      <span
                                        className="input-group-text serchcolor"
                                        id="inputGroup-sizing-default"
                                      >
                                        <img
                                          className="search"
                                          src="/images/New/Searchicon.png"
                                          alt=""
                                        />
                                      </span>
                                      <input
                                        type="text"
                                        className="form-control searchb ps-0 py-3"
                                        aria-label="Sizing example input"
                                        aria-describedby="inputGroup-sizing-default"
                                        placeholder="Search by name..."
                                        //   onChange={handleSearchArticle}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className=" mb-5">
                            <div className=" learnerscorner">
                              <div className="row">
                                <div className="col-md-4">
                                  <div className="card">
                                    <Link to="">
                                      <img
                                        className="card-img-top"
                                        src="/images/New/product-solution/videoimg.png"
                                      />
                                    </Link>
                                    <div className="card-body px-0">
                                      <Link to="">
                                        <div className="card-title">
                                          artical 1
                                        </div>
                                      </Link>
                                      <div className="card-text">
                                        hello artical 1
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="d-inline-block articlebtn">
                            <button
                              type="button"
                              class="btn btn-outline-primary mx-auto"
                              // onClick={(e) => handleArticleLimit(e, 1)}
                            >
                              View All Articles
                            </button>
                          </div>
                        </div>
                      </TabPanel>
                    </Tabs> */}
                  </div>
                  {nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[4] &&
                  nfoPage.details[4].faqs &&
                  nfoPage.details[4].faqs.length > 0 ? (
                    <div className="faqsection">
                      <div>
                        <h2 className="faqheading">FAQs</h2>

                        <div className="accordion faqacord">
                          {nfoPage &&
                            nfoPage.details &&
                            nfoPage.details[4] &&
                            nfoPage.details[4].faqs &&
                            nfoPage.details[4].faqs.length > 0 &&
                            nfoPage.details[4].faqs.map((item, index) => (
                              <div className="item">
                                <div
                                  className="title"
                                  onClick={() => faqtoggle(index)}
                                >
                                  <h2>{item.title ? item.title : ""}</h2>
                                  <div>
                                    <img
                                      className={
                                        faqSelected === index ? "rotate" : ""
                                      }
                                      src="/images/New/product-solution/bluearrow.svg"
                                    />
                                  </div>
                                </div>
                                <div
                                  className={
                                    faqSelected === index
                                      ? "content show"
                                      : "content"
                                  }
                                >
                                  {item.description ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.description,
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </section>
              :''}
            <div className="my-4">
              <div className="d-md-flex">
                <div className="productLabelling mb-3">
                  {nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[5] &&
                  nfoPage.details[5].productLabelling &&
                  nfoPage.details[5].productLabelling.title ? (
                    <h2>{nfoPage.details[5].productLabelling.title}</h2>
                  ) : (
                    ""
                  )}
                  {/* {nfoPage &&
                    nfoPage.details &&
                    nfoPage.details[5] &&
                    nfoPage.details[5].productLabellingImage ? (
                    <img
                      src={
                        nfoPage &&
                          nfoPage.details &&
                          nfoPage.details[5] &&
                          nfoPage.details[5].productLabellingImage &&
                          nfoPage.details[5].productLabellingImage.url
                          ? nfoPage.details[5].productLabellingImage.url
                          : ""
                      }
                      alt={
                        nfoPage &&
                          nfoPage.details &&
                          nfoPage.details[5] &&
                          nfoPage.details[5].productLabellingImage &&
                          nfoPage.details[5].productLabellingImage &&
                          nfoPage &&
                          nfoPage.details &&
                          nfoPage.details[5] &&
                          nfoPage.details[5].productLabellingImage &&
                          nfoPage.details[5].productLabellingImage.alt
                          ? nfoPage &&
                          nfoPage.details &&
                          nfoPage.details[5] &&
                          nfoPage.details[5].productLabellingImage &&
                          nfoPage.details[5].productLabellingImage.alt
                          : ""
                      }
                      className="img-fluid"
                    />
                  ) : (
                    ""
                  )} */}

                  {nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[0] &&
                  nfoPage.details[0].Overview &&
                  nfoPage.details[0].Overview.risk &&
                  nfoPage.details[0].Overview.risk[0] &&
                  nfoPage.details[0].Overview.risk[0].iconUrl[0] &&
                  nfoPage.details[0].Overview.risk[0].iconUrl[0].value ? (
                    <img
                      src={
                        nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[0] &&
                        nfoPage.details[0].Overview &&
                        nfoPage.details[0].Overview.risk &&
                        nfoPage.details[0].Overview.risk[0] &&
                        nfoPage.details[0].Overview.risk[0].iconUrl[0] &&
                        nfoPage.details[0].Overview.risk[0].iconUrl[0].value
                      }
                      className="img-fluid mt-2"
                    />
                  ) : (
                    ""
                  )}
                </div>
                
                {
                  nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[5] &&
                  nfoPage.details[5].benchmarkRiskometer ?
                  (
                    <>
                      {
                        nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[5] &&
                        nfoPage.details[5].benchmarkRiskometer &&
                        nfoPage.details[5].benchmarkRiskometer.values ?
                        (
                          <div className="benchmarkrisk ms-4">
                            <h2>
                              {
                                nfoPage &&
                                nfoPage.details &&
                                nfoPage.details[5] &&
                                nfoPage.details[5].benchmarkRiskometer &&
                                nfoPage.details[5].benchmarkRiskometer.title ?
                                nfoPage.details[5].benchmarkRiskometer.title : ""
                              }
                            </h2>

                            {
                              nfoPage &&
                              nfoPage.details &&
                              nfoPage.details[5] &&
                              nfoPage.details[5].benchmarkRiskometer &&
                              nfoPage.details[5].benchmarkRiskometer.values ? (
                                <div dangerouslySetInnerHTML={{__html: nfoPage.details[5].benchmarkRiskometer.values}} />
                              ) : ""
                            }
                          </div>
                        ) : ""
                      }
                    </>
                  ) : ""
                }

                {
                  nfoPage &&
                  nfoPage.details &&
                  nfoPage.details[5] &&
                  nfoPage.details[5].potentialRiskClass ? 
                  (
                    <>
                      {
                        nfoPage &&
                        nfoPage.details &&
                        nfoPage.details[5] &&
                        nfoPage.details[5].potentialRiskClass.values ?
                        (
                          <div className="prctable ms-3">
                            <h2>Potential Risk Class (PRC)</h2>
                            {
                              nfoPage &&
                              nfoPage.details &&
                              nfoPage.details[5] &&
                              nfoPage.details[5].potentialRiskClass.values ?
                              (
                                <div dangerouslySetInnerHTML={{
                                  __html: nfoPage.details[5].potentialRiskClass.values
                                }} />
                              ) : ""
                            }
                          </div>
                        ) : ""
                      }
                    </>
                  ) : ""
                }
              </div>

              {nfoPage &&
              nfoPage.details &&
              nfoPage.details[5] &&
              nfoPage.details[5].productLabelling &&
              nfoPage.details[5].productLabelling.values ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: nfoPage.details[5].productLabelling.values,
                  }}
                />
              ) : (
                ""
              )}

              {/* <img className="img-fluid w-100" src={productDetailOverview &&
                productDetailOverview.productOverview &&
                productDetailOverview.productOverview.details && productDetailOverview.productOverview.details[9] && productDetailOverview.productOverview.details[9].productLabelling &&
                productDetailOverview.productOverview.details[9].productLabelling.url ? productDetailOverview.productOverview.details[9].productLabelling.url : ''
              } alt={productDetailOverview &&
                productDetailOverview.productOverview &&
                productDetailOverview.productOverview.details && productDetailOverview.productOverview.details[9] && productDetailOverview.productOverview.details[9].productLabelling &&
                productDetailOverview.productOverview.details[9].productLabelling.alt ? productDetailOverview.productOverview.details[9].productLabelling.alt : ''} /> */}
            </div>
          </div>
        </div>
      </section>

      {/* <Modal
        isOpen={modalshow}
        onRequestClose={modalhandleClose}
        contentLabel="compare Modal"
        className="compareModal"
       
      >
        <div className="cfmodal">
          <div className="closebtn cursorp" onClick={modalhandleClose}>
            <img src="/images/New/close-circleclose.svg" />
          </div>
          <div className="comparefundmodal">
            <h3>Compare Funds</h3>
            <p className="my-3 bluetext">
              Compare Funds to decide which fund best suits you.
            </p>
            <div className="form-check form-switch d-flex align-items-center mb-4 p-0">
              <label className="form-check-label">Direct</label>
              <input
                className="form-check-input colorSwitch"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault1"
                defaultChecked="checked"
               
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckDefault1"
              >
                Regular
              </label>
            </div>

            <div className="search">
              <div className="searchInputs">
                <div className="searchIcon">
                  <img
                    className="search"
                    src="/images/New/grey-search.svg"
                    alt=""
                  />
                </div>
                <input
                  type="text"
                  placeholder="Search Funds"
               
                />
              </div>
              <div className="dataResult">
                <a
                  className="dataItem"
                  href="javascript:void(0)"
                  
                >
                  <p>okuh</p>
                </a>
              </div>
            </div>
            <p className="mt-4">Note : You can select upto 3 funds.</p>
            <div className="row gx-4 my-4">
              <div className="col-md-4 mb-4">
                <div className="card allFundCard h-100">
                  <div className="card-body p-3">
                    <div className="card-title">
                      <div className="mainTitle d-flex justify-content-between">
                        <div className="text-break fundHeading">hdfc fund</div>

                        <label className="checkboxc">
                          <input
                            type="checkbox"
                            
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    </div>
                    
                    <div className="card-text">
                      <div className="aboutfunds">
                        <div className="my-4">
                          <a
                            className="btn fundSubTitlebtn active mb-3"
                           
                          >
                            abc
                          </a>
                        </div>
                        <div>
                          <div className="row pb-3">
                            <div className="col-6">
                              <p className="fundtitle">CAGR</p>
                              <p className="fundpercentage">NA</p>
                            </div>
                            <div className="col-6">
                              <p className="fundtitle">Benchmark Returns</p>
                              <p className="fundpercentage">NA</p>
                            </div>
                          </div>
                        </div>
                        <div className="cardfundrow">
                          <div className="row  my-3">
                            <div className="col-6">
                              <p className="fundheadingsec">NAV (async)</p>
                              <p className="fundpercentage">NA</p>
                            </div>
                            <div className="col-6">
                              <p className="fundheadingsec">Risk Rating</p>
                              <p className="d-flex align-items-center fundpercentage">
                                <img src="" className="img-fluid riskimg" />
                                <span className="reduceFontsize ms-1">
                                  very high
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="benchMarkFund mb-4">
                          benchmarktitle
                          <span className="ms-3">benchmarkvalue</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ordiv my-4">
              <hr />
              <span className="orcls px-3">Or</span>
            </div>

            <h3 className="mb-4">Funds in Focus</h3>

            <div className="treandingscheme">
              <div className="mb-3 d-flex justify-content-between align-items-center p-3 fundbox">
                <p>fund name</p>
                <label className="checkboxc">
                  <>
                    <input
                      type="checkbox"
                      // value={item.nodeID ? item.nodeID : ""}
                      // checked={item.checked}
                      // onChange={(e) => handleCompareCheckBox(item)}
                    />
                    <span className="checkmark"></span>
                  </>
                </label>
              </div>
            </div>
          </div>
          <div>
            <button className="btn btn-outline-primary">
              <Link
                to={getRouting(
                  "/product-solutions/compare-funds",
                  "Compare Funds"
                )}
              >
                Select from list
              </Link>
            </button>
            <button className="btn btn-primary" onClick={() => handleModal()}>
              <Link
                to={{
                  pathname: "/product-solutions/comparefunds-details",
                 
                }}
              >
                Compare Funds
              </Link>
            </button>
          </div>
        </div>
      </Modal> */}</>:<PageNotFound/>}
    </div>
  );
};
const mapStateToProps = (state) => ({
  nfoOverview: state.ProductSolution.home.productAllFund,
});

const mapDispatchToProps = (dispatch) => ({
  getNfoOverview: bindActionCreators(getNfoOverview, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NfoOverview);
